/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Assignment Timezone Field
 *
 * @file AssignmentTimezoneField.jsx
 * @author Gladson Samuel S
 * @since 2.0.0
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import AetTimezone from '../common/AetTimeZone';
import Icon from '../icons/Icon';
import { ASSIGNMENT_FORM_TIMEZONE_FIELD_CLASS } from '../../common/constants';

const AssignmentTimezoneField = ({
  name,
  control,
  label,
  rules,
  options,
  onChange: onChangeCallback
}) => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    render={({ field }) => (
      <AetTimezone
        className={ASSIGNMENT_FORM_TIMEZONE_FIELD_CLASS}
        label={label}
        value={field.value || ''}
        onChange={(value) => {
          field.onChange(value);
          onChangeCallback?.(value);
        }}
        options={options}
        icons={{
          timeZone: <Icon name="TimeZoneIcon" style={{ fontSize: 18, width: 18, height: 18 }} />
        }}
      />
    )}
  />
);

AssignmentTimezoneField.propTypes = {
  name: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  rules: PropTypes.object,
  options: PropTypes.array,
  onChange: PropTypes.func
};

AssignmentTimezoneField.defaultProps = {
  rules: undefined,
  options: [],
  onChange: null
};

export default AssignmentTimezoneField;
